import { render, staticRenderFns } from "./suggestionDetailAppr.vue?vue&type=template&id=3db768ce"
import script from "./suggestionDetailAppr.vue?vue&type=script&lang=js"
export * from "./suggestionDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db768ce')) {
      api.createRecord('3db768ce', component.options)
    } else {
      api.reload('3db768ce', component.options)
    }
    module.hot.accept("./suggestionDetailAppr.vue?vue&type=template&id=3db768ce", function () {
      api.rerender('3db768ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/sug/suggestionDetailAppr.vue"
export default component.exports